import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <pre><code parentName="pre" {...{
        "className": "language-swift",
        "metastring": "file=AppDelegate.swift focusOnLines=7-14",
        "file": "AppDelegate.swift",
        "focusOnLines": "7-14"
      }}>{`let POSTHOG_API_KEY = "<ph_project_api_key>"
// usually 'https://us.i.posthog.com' or 'https://eu.i.posthog.com'
let POSTHOG_HOST = "<ph_client_api_host>"

let config = PostHogConfig(apiKey: POSTHOG_API_KEY, host: POSTHOG_HOST)

// capture screen views
config.captureScreenViews = true 
// capture application lifecycle events (installed, updated, opened, backgrounded)
config.captureApplicationLifecycleEvents = true
// capture element interactions (button presses, text input changes, etc.)
config.captureElementInteractions = true // TIP: Disabled by default

PostHogSDK.shared.setup(config) 
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      